import { Phone } from '@hc-frontend/core-icons/kit';
import { Link, usePhoneCampaign } from '@hc-frontend/core-ui';

export default function FooterCallComponent() {
  const phoneCampaign = usePhoneCampaign();

  if (phoneCampaign) {
    return (
      <div className="text-secondary-variant-900 flex">
        <Phone className="w-[20px] h-[20px] right-4-4" />
        &nbsp;
        <Link
          href={phoneCampaign?.href}
          className="hc-btn--text text-l p-[0] font-bold leading-[calc(var(--font-size-heading-three)*0.85)] focus:no-underline"
          id="call_now_link"
          placement={phoneCampaign?.placement}
          data-call-call-type={phoneCampaign?.callType}
          data-call-placement={phoneCampaign?.placement}
          data-call-product={phoneCampaign?.product}
          data-call-phone={phoneCampaign?.href}
          data-call-advertiser={phoneCampaign?.advertiser}
        >
          {phoneCampaign?.phoneNumber}
        </Link>
      </div>
    );
  }

  return null;
}
